import { render, staticRenderFns } from "./ContactForm2.vue?vue&type=template&id=0e86138e&scoped=true&"
import script from "./ContactForm2.vue?vue&type=script&lang=js&"
export * from "./ContactForm2.vue?vue&type=script&lang=js&"
import style0 from "./ContactForm2.vue?vue&type=style&index=0&id=0e86138e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e86138e",
  null
  
)

export default component.exports